import { Timestamp } from 'components/timekeeping/timestamp'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { makeGetStatus } from '../../../reduxes/slices/api/selectors'
import { getSelectedDirectChatHandle } from '../../../reduxes/slices/selected/selectors'
import { getSelectedTopic } from '../../../reduxes/slices/topics/selectors'
import Timeline from '../timeline'

const START_OF_TOPIC_STATUS_MESSAGE = 'START'

export default function Status({ timeline }) {
  const getStatus = useMemo(makeGetStatus, [])
  const status = useSelector((state) => getStatus(state, timeline?.tl_id))
  const selectedTopic = useSelector(getSelectedTopic)
  const selectedDMHandle = useSelector(getSelectedDirectChatHandle)

  if (!timeline || !status) return null

  let startMessage
  if (status.message === START_OF_TOPIC_STATUS_MESSAGE) {
    switch (selectedTopic.participant_mode) {
      case 'group_chat':
      case 'live_chat':
        startMessage = `This is the beginning of the ${selectedTopic.subject} topic`
        break
      case 'direct_chat':
        startMessage = `This is the start of your conversation with ${selectedDMHandle}`
        break
    }
  }

  return (
    <Timeline
      timeline={timeline}
      item={status}
      avatar={<div className="timeline__status__line topic-avatar" />}
      avatarType="readonly"
      withTimelineInfo={false}
      className="timeline__status"
    >
      {!startMessage && (
        <div
          className="timeline__status__message-container"
          dangerouslySetInnerHTML={{ __html: status.message }}
        />
      )}
      {!!startMessage && startMessage}&nbsp;
      <Timestamp
        className="timeline__status__timestamp"
        date={status.updated_at}
      />
    </Timeline>
  )
}

Status.propTypes = {
  timeline: PropTypes.object.isRequired,
}
